import * as tslib_1 from "tslib";
import update from 'immer';
import { isType } from './actions';
export function createReducer(initialState) {
  return makeReducer(initialState);
}
export function reducerWithoutInitialState() {
  return makeReducer();
}
export function upcastingReducer() {
  return makeReducer();
}

function makeReducer(initialState) {
  var cases = [];
  var reducer = getReducerFunction(initialState, cases);

  reducer.caseAction = function (actionCreator, handler) {
    cases.push({
      actionCreator: actionCreator,
      handler: handler
    });
    return reducer;
  };

  reducer.case = function (actionCreator, handler) {
    return reducer.caseAction(actionCreator, function (state, action) {
      return handler(state, action.payload);
    });
  };

  reducer.build = function () {
    return getReducerFunction(initialState, cases.slice());
  };

  return reducer;
}

function getReducerFunction(initialState, cases) {
  return function (curState, action) {
    if (curState === void 0) {
      curState = initialState;
    }

    var e_1, _a;

    var _loop_1 = function _loop_1(actionCreator, handler) {
      if (isType(action, actionCreator)) {
        return {
          value: update(curState, function (draftState) {
            return handler(draftState, action);
          })
        };
      }
    };

    try {
      for (var cases_1 = tslib_1.__values(cases), cases_1_1 = cases_1.next(); !cases_1_1.done; cases_1_1 = cases_1.next()) {
        var _b = cases_1_1.value,
            actionCreator = _b.actionCreator,
            handler = _b.handler;

        var state_1 = _loop_1(actionCreator, handler);

        if (typeof state_1 === "object") return state_1.value;
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (cases_1_1 && !cases_1_1.done && (_a = cases_1.return)) _a.call(cases_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }

    return curState;
  };
}